import React from 'react';

/**
 * AIPPT相关的自定义Hook
 * 用于处理AIPPT会话历史记录和相关逻辑
 */
    //处理AIPPT会话历史记录

export const useAippt = (changeSessionMapItem) => {


    /**
     * 检查是否为AIPPT消息
     * @param {Array} messages - 消息数组
     * @returns {boolean} - 是否为AIPPT消息
     */
    const isAipptMessage = (messages) => {
        // 🔥 修复：不仅检查handler，还检查content_type（支持通用技能下的AIPPT内容）
        return messages && messages.length > 0 && (
            messages[0]?.handler === 'aippt' ||
            messages.some(msg => msg.content_type && msg.content_type.startsWith('aippt_'))
        );
    };

    /**
     * 设置AIPPT会话ID到localStorage
     * @param {string} sessionId - 会话ID
     */
    const setAipptSessionId = (sessionId) => {
        if (sessionId) {
            localStorage.setItem('aippt_prev_session_id', sessionId);
        }
    };

    /**
     * 获取AIPPT会话ID从localStorage
     * @returns {string|null} - 会话ID
     */
    const getAipptSessionId = () => {
        return localStorage.getItem('aippt_prev_session_id');
    };

    return {
        isAipptMessage,
        setAipptSessionId,
        getAipptSessionId,
        // expose a bound handler for convenience
        handleAIPPTHistoryMessage: (historyMessage, session) => handleAIPPTHistoryMessage(changeSessionMapItem, historyMessage, session)
    };
};
export const handleAIPPTHistoryMessage = async (changeSessionMapItem, historyMessage, session = {}) => {
    try {
        
        // 🔥 对AIPPT历史消息进行安全检查和格式化
        const safeHistoryMessages = historyMessage.map((msg, index) => {
            if (!msg || !msg.content) {
                return msg;
            }

            let safeContent = msg.content;

            // 检查 content 是否为普通对象（非 React 元素）
            if (safeContent && typeof safeContent === 'object' && !React.isValidElement(safeContent) && safeContent.constructor === Object) {
                // 检查是否为AIPPT相关的数据结构
                const isAIPPTData =
                    safeContent.ongoing_status !== undefined ||
                    safeContent.theme !== undefined ||
                    safeContent.catalogs !== undefined ||
                    safeContent.title !== undefined ||
                    safeContent.cover_image_list !== undefined ||
                    safeContent.images_url !== undefined ||
                    safeContent.color !== undefined ||
                    safeContent.style !== undefined ||
                    safeContent.id !== undefined ||
                    safeContent.status !== undefined;

            }

            // 🔥 关键修复：完整保留所有 AIPPT 相关字段
            // 这些字段对于 AIPPT/index.jsx 的 getItem() 正确渲染至关重要
            
            // 🔥 新增：自动检测是否为AIPPT内容（即使handler不是'aippt'）
            const hasAipptContentType = msg.content_type && msg.content_type.startsWith('aippt_');
            const shouldSetAipptHandler = hasAipptContentType || msg.handler === 'aippt';
            
            return {
                ...msg,
                content: safeContent,
                // 🔥 核心字段：确保这些字段不会丢失
                content_type: msg.content_type || (msg.handler === 'aippt' ? 'aippt_catalog' : undefined),
                // 🔥 关键修复：如果消息包含AIPPT相关的content_type，自动设置handler为'aippt'
                // 这样即使在通用技能下生成的AIPPT内容，也能正确渲染
                handler: shouldSetAipptHandler ? 'aippt' : msg.handler,
                message_type: msg.message_type,
                // 🔥 额外保留的AIPPT专用字段
                _id: msg._id,
                agent_id: msg.agent_id,
                session_id: msg.session_id,
                skill_id: msg.skill_id,
                role: msg.role,
                create_time: msg.create_time,
                update_time: msg.update_time,
                // 🔥 保留可能的API数据
                apiData: msg.apiData,
                pptData: msg.pptData,
                pptId: msg.pptId
            };
        });
        
        // 更新 sessionMap 中的AIPPT会话数据
        if (changeSessionMapItem && typeof changeSessionMapItem === 'function') {
            // 🔥 修复：使用正确的字段名，session.session_id而不是session.sessionId
            const sessionId = session?.session_id || session?.sessionId;

            // 🔥 新增：更新localStorage中的AIPPT会话ID，确保AIPPT组件能正确读取
            // 🔥 修复：不仅检查handler，还检查content_type（支持通用技能下的AIPPT内容）
            const hasAipptContent = historyMessage && historyMessage.length > 0 && (
                historyMessage[0]?.handler === 'aippt' ||
                historyMessage.some(msg => msg.content_type && msg.content_type.startsWith('aippt_'))
            );
            
            if (sessionId && hasAipptContent) {
                localStorage.setItem('aippt_prev_session_id', sessionId);
            }   

            changeSessionMapItem(
                sessionId,
                {
                    messages: safeHistoryMessages,
                    loading: false,
                    answering: false
                },
                safeHistoryMessages
            );
        }
    } catch (error) {
        console.error('🔥 处理AIPPT历史记录出错:', error);
    }
};

export default useAippt;
